import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './NavigationBar.css';
import { NavigationLinkTypes } from '../../../constants/navigation';
import { trackShowMap } from '../../../tracking';
import { TNavigationLinkType } from '../../../types';
import { NavigationLinks } from '../NavigationLinks';
import { getOffsetTop } from '../helpers';

type TScrolled = 'left' | 'right';

interface INavigationBarState {
  scrolled: TScrolled;
  useScroll: boolean;
  activeTab?: TNavigationLinkType;
  isTrackShowMapFired: boolean;
}

interface INavigationBarProps {
  isNavigationFixed?: boolean;
  links: TNavigationLinkType[];
  isFat?: boolean;
}

export class NavigationBar extends React.PureComponent<INavigationBarProps, INavigationBarState> {
  public state: INavigationBarState = {
    scrolled: 'left',
    useScroll: false,
    activeTab: undefined,
    isTrackShowMapFired: false,
  };
  private container = React.createRef<HTMLDivElement>();
  private linksWrapper = React.createRef<HTMLDivElement>();
  private mounted = false;

  public componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  }

  public componentDidUpdate() {
    const { activeTab, isTrackShowMapFired } = this.state;
    // в componentDidMount вызывается до полного рендера NavigationLinks и размер контейнера linksWrapper равен 0
    // первый раз componentDidUpdate выполнится после рендера NavigationLinks и контейнер linksWrapper уже имеет размер
    // флаг mounted нужен чтобы только 1 раз выполнить handleResize
    if (!this.mounted) {
      this.mounted = true;
      this.handleResize();
    }

    if (activeTab === NavigationLinkTypes.Map && !isTrackShowMapFired) {
      trackShowMap();
      this.setState({
        isTrackShowMapFired: true,
      });
    }
  }

  public render() {
    const { useScroll, scrolled, activeTab } = this.state;

    const { links, isNavigationFixed, isFat } = this.props;

    const showArrow = useScroll && (scrolled === 'left' ? 'right' : 'left');

    return (
      <div ref={this.container} {...mergeStyles(styles['container'], isNavigationFixed && styles['container--fixed'])}>
        <div ref={this.linksWrapper} {...mergeStyles(styles['links'], scrolled === 'right' && styles['links-right'])}>
          <NavigationLinks
            links={links}
            className={isNavigationFixed ? undefined : styles['link-not-fixed']}
            activeLink={activeTab}
            isFat={isFat}
          />
        </div>
        {showArrow && this.renderArrow(showArrow)}
      </div>
    );
  }

  private renderArrow = (scrolled: TScrolled) => (
    <div className={styles[`${scrolled}-gradient` as 'right-gradient' | 'left-gradient']}>
      <div
        onClick={() => this.setState({ scrolled })}
        {...mergeStyles(
          styles['arrow'],
          this.props.isNavigationFixed && styles['arrow-fixed'],
          styles[`${scrolled}-arrow` as 'right-arrow' | 'left-arrow'],
        )}
      />
    </div>
  );

  private handleResize = () => {
    if (this.container.current && this.linksWrapper.current) {
      const { offsetWidth } = this.container.current;

      const useScroll = offsetWidth < this.linksWrapper.current.offsetWidth;

      if (useScroll && !this.state.useScroll) {
        this.setState({ useScroll: true });
      }

      if (!useScroll && this.state.useScroll) {
        this.setState({ useScroll: false, scrolled: 'left' });
      }
    }
  };

  private handleScroll = () => {
    const { isNavigationFixed, links } = this.props;
    const offset = 52 + 8;
    let activeLink: TNavigationLinkType = 'main_info';
    if (isNavigationFixed) {
      // отступ сверху, высота хедера с навигацией + отступ
      links.forEach(link => {
        const element = document.querySelector<HTMLDivElement>(`#${link}`);
        if (!!element && window.pageYOffset >= getOffsetTop(element, offset)) {
          activeLink = link;
        }
      });
    }

    this.setState({ activeTab: activeLink });
  };
}
